//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qrCodeImg from 'assets/home/erweima_19.jpg'
export default {
  data () {
    return {
      qrCodeImg
    }
  },
  components: {

  },
  methods: {
    goRoute (val) {
      this.$router.push({name: 'aboutOur', params: {'active': val}})
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/layouts/footer.vue